<div class="outlet-container" #outletContainer>
    <app-navbar *ngIf="headerVisible"></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <!--<app-allow-cookies></app-allow-cookies>-->
</div>
